import { Routes } from '@angular/router';
import { adminRoutes } from './sub-routes/admin-route';
import { rdManagerRoutes } from './sub-routes/rd-manager-routes';
import { storekeeperRoutes } from './sub-routes/storekeeper-route';
import { profileRoutes } from './sub-routes/profile-routes';
import { odManagerRoutes } from './sub-routes/od-manager-routes';
import { hrManagerRoutes } from './sub-routes/hr-manager-route';
import { trainingRoutes } from './sub-routes/training-center-route';
import { interviewerRoutes } from './sub-routes/interviewer-route';
import { supervisorRoutes } from './sub-routes/supervisor-route';
import { QCOfficerRoutes } from './sub-routes/qc-officer.route';
import { ScripterRoutes } from './sub-routes/scripter-route';
import { CatiRoutes } from './sub-routes/cati-route';
import { ManagementRoutes } from './sub-routes/management-route';
import { DataCheckerRoutes } from './sub-routes/data-checker-route';
import { DataCleanerRoutes } from './sub-routes/data-cleaner-route';
import { DataProcessorRoutes } from './sub-routes/data-processor-route';
import { paymentRoutes } from './sub-routes/payment-route';
import { FinanceRoutes } from './sub-routes/finance.route';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth/login',
    loadComponent: () =>
      import('../pages/auth/login/login').then((m) => m.Login),
    data: {
      isSidebar: 0,
      isHeader: 0,
    },
  },
  {
    path: 'interviewer-onboarding',
    loadComponent: () =>
      import('../pages/auth/external-onboarding/external-onboarding').then(
        (m) => m.ExternalOnboarding
      ),
    data: {
      isSidebar: 0,
      isHeader: 0,
    },
  },
  {
    path: 'auth/forget-password',
    loadComponent: () =>
      import('../pages/auth/forget-password/forget-password').then(
        (m) => m.ForgetPassword
      ),
    data: {
      isSidebar: 0,
      isHeader: 0,
    },
  },

  {
    path: 'auth/first-login-reset',
    loadComponent: () =>
      import('../pages/auth/first-login-reset/first-login-reset').then(
        (m) => m.FirstLoginReset
      ),
    data: {
      isSidebar: 0,
      isHeader: 0,
    },
  },
  {
    path: 'auth/reset-password',
    loadComponent: () =>
      import('../pages/auth/reset-password/reset-password').then(
        (m) => m.ResetPassword
      ),
  },
  {
    path: 'task-management',
    canActivate: [AuthGuard.canActivate],
    loadComponent: () =>
      import('../pages/common/task-management/all-tasks/all-tasks').then(
        (m) => m.AllTasks
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
  {
    path: 'task-management/:id/details',
    canActivate: [AuthGuard.canActivate],
    loadComponent: () =>
      import(
        '../pages/common/task-management/all-tasks/task-progress-details/task-progress-details'
      ).then((m) => m.TaskProgressDetails),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
  // {
  //   path: 'auth/change-password',
  //   loadComponent: () => import('../pages/auth/change-password/change-password').then(m => m.ChangePassword),
  //    data: {
  //     isSidebar: 1,
  //     isHeader: 1,
  //   }
  // },
  {
    path: 'auth/select-roles',
    loadComponent: () =>
      import('../pages/auth/select-roles/select-roles').then(
        (m) => m.SelectRoles
      ),
  },
  {
    path: 'performance-management',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import(
        '../pages/common/performance-management/performance-management/performance-management'
      ).then((m) => m.PerformanceManagement),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: ['Admin', 'OD Manager', 'RD Manager', 'Management'],
    },
  },
  {
    path: 'communication',
    canActivate: [AuthGuard.canActivate],
    loadComponent: () =>
      import('../pages/common/communication/communication').then(
        (m) => m.Communication
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: ['Admin', 'OD Manager', 'RD Manager'],
    },
  },
  {
    path: 'admin',
    canActivate: [AuthGuard.canActivate],
    children: adminRoutes,
  },
  {
    path: 'rd-manager',
    canActivate: [AuthGuard.canActivate],
    children: rdManagerRoutes,
  },
  {
    path: 'storekeeper',
    canActivate: [AuthGuard.canActivate],
    children: storekeeperRoutes,
  },
  {
    path: 'user',
    canActivate: [AuthGuard.canActivate],
    children: profileRoutes,
  },
  {
    path: 'payment',
    canActivate: [AuthGuard.canActivate],
    children: paymentRoutes,
  },
  {
    path: 'od-manager',
    canActivate: [AuthGuard.canActivate],
    children: odManagerRoutes,
  },
  {
    path: 'hr-manager',
    canActivate: [AuthGuard.canActivate],
    children: hrManagerRoutes,
  },
  {
    path: 'training',
    canActivate: [AuthGuard.canActivate],
    children: trainingRoutes,
  },
  {
    path: 'interviewer',
    canActivate: [AuthGuard.canActivate],
    children: interviewerRoutes,
  },
  {
    path: 'supervisor',
    canActivate: [AuthGuard.canActivate],
    children: supervisorRoutes,
  },
  {
    path: 'qc-officer',
    canActivate: [AuthGuard.canActivate],
    children: QCOfficerRoutes,
  },
  {
    path: 'scripter',
    canActivate: [AuthGuard.canActivate],
    children: ScripterRoutes,
  },
  {
    path: 'cati',
    canActivate: [AuthGuard.canActivate],
    children: CatiRoutes,
  },
  {
    path: 'management',
    canActivate: [AuthGuard.canActivate],
    children: ManagementRoutes,
  },
  {
    path: 'data-checker',
    canActivate: [AuthGuard.canActivate],
    children: DataCheckerRoutes,
  },
  {
    path: 'data-cleaner',
    canActivate: [AuthGuard.canActivate],
    children: DataCleanerRoutes,
  },
  {
    path: 'data-processor',
    canActivate: [AuthGuard.canActivate],
    children: DataProcessorRoutes,
  },
  {
    path: 'finance',
    canActivate: [AuthGuard.canActivate],
    children: FinanceRoutes,
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  },
];
